import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/auth/useAuth";

/** Pages for signed-out visitors (login, sign-up); signed-in users go to the app. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const { status } = useAuth();

  if (status === "loading") return null;
  if (status === "signedIn") return <Navigate to="/" replace />;
  return children;
}
